import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useKanbanBoardRowStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            'margin': 0,
            'flex': '1 0 auto',
            'display': 'flex',
            'flexDirection': 'column',

            '&:not(:first-child)': {
                borderTop: 'solid 1px #D4D4D4'
            }
        },
        header: {
            height: 39,
            fontSize: 16,
            position: 'sticky',
            top: 0,
            zIndex: 1,
            padding: '0px 16px',
            cursor: 'pointer',
            gap: 12,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: '#F1F1F1',
            borderBottom: 'solid 1px #D4D4D4'
        },
        leading: {
            gap: 8,
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center'
        },
        trailing: {
            gap: 12,
            display: 'inline-flex',
            alignItems: 'center',
            flexShrink: 0
        },
        title: {
            gap: 8,
            margin: 0,
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            lineHeight: 1,
            fontWeight: 600,
            display: 'inline-flex',
            alignItems: 'center'
        },
        titleText: {
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        counter: {
            width: 28,
            height: 28,
            flexShrink: 0,
            color: '#fff',
            fontSize: 16,
            fontWeight: 500,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#000',
            borderRadius: '100%'
        },
        content: {
            'gap': 16,
            'flex': '1 0 auto',
            'display': 'flex',
            'flexDirection': 'column',

            '&:not([data-has-children="false"])': {
                padding: '16px 0px 2px',
                border: 'solid 1px transparent'
            },
            '&[data-drop-target="true"]': {
                minHeight: 120,
                overflow: 'hidden',
                border: 'dashed 1px #EAB464',
                backgroundColor: 'rgba(234, 180, 100, 0.1)'
            }
        }
    })
);
